import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "wiCltN",
    defaultMessage: "Company Information",
    description: "wizard step title",
  },
  description: {
    id: "KX1kX0",
    defaultMessage:
      "Set up your business details. This information will appear on invoices and receipts.",
    description: "wizard step description",
  },
  successMessage: {
    id: "or/Jm7",
    defaultMessage: "Company information saved",
    description: "wizard step success notification",
  },
  errorMessage: {
    id: "kcgtTl",
    defaultMessage: "Failed to save company information",
    description: "wizard step error notification",
  },
  companyName: {
    id: "I02Mx/",
    defaultMessage: "Company Name",
    description: "form field label",
  },
  companyDescription: {
    id: "mf3b7h",
    defaultMessage: "Company Description",
    description: "form field label",
  },
  streetAddress: {
    id: "a+Cefz",
    defaultMessage: "Street Address",
    description: "form field label",
  },
  streetAddressLine2: {
    id: "jh7ONW",
    defaultMessage: "Street Address (Line 2)",
    description: "form field label",
  },
  city: {
    id: "DXbekW",
    defaultMessage: "City",
    description: "form field label",
  },
  postalCode: {
    id: "wsIBFg",
    defaultMessage: "Postal Code",
    description: "form field label",
  },
  country: {
    id: "HW8jBM",
    defaultMessage: "Country",
    description: "form field label",
  },
  stateProvince: {
    id: "IDpirv",
    defaultMessage: "State / Province",
    description: "form field label",
  },
  phone: {
    id: "4tHiz7",
    defaultMessage: "Phone",
    description: "form field label",
  },
  businessDetailsSection: {
    id: '3BRRKi',
    defaultMessage: "Business Details",
    description: "form section label",
  },
  addressSection: {
    id: 'hLJdWJ',
    defaultMessage: "Address",
    description: "form section label",
  },
  contactSection: {
    id: 'bEFgW7',
    defaultMessage: "Contact Information",
    description: "form section label",
  },
});
